import React from "react";
import { NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveTab } from "../../../store/activeTabSlice";
import { cn } from "../../common/u1/cn";

/* One row in the dashboard rail. */
export const SidebarNavItem = ({
  name,
  link,
  Icon,
  alert = false,
  accent = false,
  collapsed = false,
  onNavigate,
}) => {
  const dispatch = useDispatch();

  /* Transcribed from SidebarLinkGroup: following a rail item records it as the
     active section, which is what the top bar shows as the page heading. */
  const handleClick = () => {
    dispatch(setActiveTab(name));
    if (onNavigate) onNavigate();
  };

  return (
  <NavLink
    to={link}
    end={link === "/dashboard"}
    onClick={handleClick}
    title={collapsed ? name : undefined}
    aria-label={collapsed ? name : undefined}
    className={({ isActive }) =>
      cn(
        /* The design's .nav-item, verbatim: 46px tall, 12px radius, 14px gap,
           16px inline padding, 14.5px/500 text, full width, left-aligned. */
        "relative flex h-[46px] w-full shrink-0 items-center rounded-xl text-left text-[14.5px] transition-colors",
        collapsed ? "justify-center px-0" : "gap-3.5 px-4",
        isActive
          ? "bg-[var(--coral)] font-semibold text-white"
          : accent
          ? "font-semibold text-[var(--coral)] hover:bg-white/[0.06]"
          : "font-medium text-[var(--sidebar-dim)] hover:bg-white/[0.06] hover:text-white"
      )
    }
  >
    {Icon && <Icon className="h-[18px] w-[18px] shrink-0" aria-hidden="true" />}
    {!collapsed && <span className="min-w-0 flex-1 truncate">{name}</span>}

    {/* Unread work in this section. Decorative — the detail lives on the page
        itself; this only says something is waiting. */}
    {alert && (
      <span
        aria-hidden="true"
        className={cn(
          "shrink-0 rounded-full bg-[var(--coral)]",
          collapsed ? "absolute right-2 top-2.5 h-[6px] w-[6px]" : "h-[7px] w-[7px]"
        )}
      />
    )}
    </NavLink>
  );
};

export default SidebarNavItem;
